module.exports = __webpack_public_path__ + "img/bg-split.65778a74.png";